<template>
  <div>
      <van-icon name="ellipsis" size="20" @click="opTicket" />
      <van-overlay :show="menuShow" @click="hide" class-name="menu_overlay">
        <div v-if="menuShow"
            class="menu_1">
            <div v-for="e in itemList"
                :key="e"
                class="menu_item">{{e}}</div>
        </div>
      </van-overlay>
  </div>
</template>

<script>
export default {
  name: "MobileTicketDetailMenu",

  props : ['items'],

  data() {
      return {
          itemList : [],
          menuShow : false
      }
  },

  watch : {
      items() {
          this.itemList = this.items;
      }
  },

  mounted() {
    this.itemList = this.items;
  },

  methods: {
    hide(e) {
        if ( !e.target.classList.contains('menu_item') ) {
            this.menuShow = false;
            return;
        }

        this.$emit('click', $(e.target).index());
        this.menuShow = false;
    },

    opTicket() {
      this.menuShow = true;
    }
  }
};
</script>

<style>
    .menu_overlay {
        background: unset;
    }

    .menu_item {
        height: 35px;
        line-height: 35px;
        border: solid 1px #f5f5f5;
        border-width: 0 0 1px 0;
    }

    .menu_1 {
        position: fixed;
        top: 50px;
        left: 50vw;
        width: 45vw;
        box-shadow: 1px 1px 5px 3px #e6e9da;
        background: white;
        border-radius: 5px;
    }
</style>


// WEBPACK FOOTER //
// src/components/mobile-ticket/MobileTicketDetailMenu.vue